import { CourseCardSkeleton } from "@features/home/components/Skeleton/CourseCardSkeleton";

const FestivalCardsListLoading = () => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 sm:gap-6 sm:gap-y-6 mb-8 gap-y-4">
      {Array(12)
        .fill("")
        .map((_, index) => (
          <CourseCardSkeleton key={index} hasAddToCart />
        ))}
    </div>
  );
};

export default FestivalCardsListLoading;
